import React, { Component, createRef, Fragment } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter, Link } from "react-router-dom"
import { isEmpty } from "lodash"
import cx from "classnames"
import Spinner from "components/common/spinner"
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock"
import history from "app/history"
import VerificationPopUp from "components/common/PopUp"
import AuthModal from "components/auth/AuthModal"
import Avatar from "components/common/Avatar"
import Button from "components/common/Button"
import Notification from "components/notification"
import VideoModal from "components/modal/VideoModal"
import CustomModal from "components/common/CustomModal"

import { AUTH_TYPES } from "constants/auth-types"
import { showAuthModal, closeAuthModal, logoutUser } from "store/auth/action"
import {
  getUserNotifications,
  getUserProfile,
  getCompliancePeriod,
} from "store/user/actions"
import NotificationIcon from "assets/icons/notif.svg"
import { FAQS_LINK } from "constants/config"

import "components/navbar/index.scss"
import { GOOGLE_ANALYTICS_KEY } from "constants/config"
import ReactGA from "react-ga"

ReactGA.initialize(GOOGLE_ANALYTICS_KEY)

class NavigationBar extends Component {
  constructor() {
    super()

    this.state = {
      isProfileExpanded: false,
      isNotificationsExpanded: false,
      showMenu: false,
      activeSubmenuItem: false,
      showVerified: false,
      showVideoModal: false,
      showAnnouncementModal: false,
    }

    this.notificationDropDown = createRef()
    this.profileDropDown = createRef()
  }

  componentWillMount() {
    this.unlisten = this.props.history.listen((location, action) => {
      ReactGA.pageview(window.location.pathname + window.location.search)
    })
  }

  componentDidMount() {
    const {
      location: { pathname, search },
      auth: { isAuthorized, userId, role },
      getUserNotifications,
      getUserProfile,
      showAuthModal,
      getCompliancePeriod,
    } = this.props

    const params = new URLSearchParams(search)
    const verifiedParam = params.get("verified")

    let currentPath = pathname.split("/")
    if (currentPath[1] === "reset_password" && !isEmpty(currentPath[2])) {
      showAuthModal({ type: AUTH_TYPES.RESET_PASSWORD })
    } else if (currentPath[1] === "login") {
      showAuthModal({ type: AUTH_TYPES.LOGIN })
    } else if (
      ((currentPath[1] === "student" && currentPath[2] === "profile") ||
        currentPath[1] === "courses") &&
      verifiedParam === "1"
    ) {
      this.setState({ showVerified: true })
    }

    if (isAuthorized) {
      getUserNotifications({ page: 1 })
      getUserProfile({ userId: userId, role })
      getCompliancePeriod()
    }
    ReactGA.pageview(window.location.pathname + window.location.search)
    window.addEventListener("scroll", this.resizeHeaderOnScroll)
    this.targetElement = document.querySelector("#root")
  }

  componentDidUpdate(prevProps) {
    const {
      auth: { isAuthorized: prevIsAuthorized },
      school: { schoolData: prevSchoolData },
    } = prevProps

    const {
      auth: { isAuthorized, userId, role },
      school: { schoolData },
      getUserProfile,
      getUserNotifications,
    } = this.props

    if (isAuthorized && isAuthorized !== prevIsAuthorized) {
      getUserProfile({ userId: userId, role })
      getUserNotifications({ page: 1 })
    }
    if (prevSchoolData && prevSchoolData !== schoolData) {
      this.setState({
        showAnnouncementModal: schoolData?.config?.products?.show_announcement,
      })
    }
    this.disableScroll()
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.resizeHeaderOnScroll, false)
    document.removeEventListener("click", this.handleOutsideClick, false)
    this.unlisten()
  }

  checkCounter(count) {
    let notificationCounter

    if (count >= 100) {
      notificationCounter = "99+"
    } else {
      notificationCounter = count
    }
    return notificationCounter
  }

  showProfileDropdown = () => {
    this.setState((prevState) => ({
      isProfileExpanded: !prevState.isProfileExpanded,
      isNotificationsExpanded: false,
    }))
    this.handleClick()
  }

  showNotificationsDropdown = () => {
    var myNotification = document.getElementById("notification-list")
    myNotification.scrollTop = 0
    const { getUserNotifications } = this.props
    const { isNotificationsExpanded } = this.state
    this.setState(
      {
        isNotificationsExpanded: !isNotificationsExpanded,
        isProfileExpanded: false,
      },
      () => {
        getUserNotifications({ page: 1 })
      }
    )
    this.handleClick()
  }

  collapseDropdown = () => {
    this.setState({
      isNotificationsExpanded: false,
      isProfileExpanded: false,
      showMenu: false,
    })
  }

  handleClick() {
    const { isProfileExpanded, isNotificationsExpanded } = this.state
    if (!isProfileExpanded) {
      document.addEventListener("click", this.handleOutsideClick, false)
    } else if (!isNotificationsExpanded) {
      document.addEventListener("click", this.handleOutsideClick, false)
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false)
    }
  }

  handleOutsideClick = (e) => {
    if (this.profileDropDown?.current?.contains(e.target)) {
      return
    } else if (this.notificationDropDown?.current?.contains(e.target)) {
      return
    } else {
      this.collapseDropdown()
    }
  }

  handleLogoutUser() {
    document.removeEventListener("click", this.handleOutsideClick, false)
    this.setState((prevState) => ({
      isProfileExpanded: !prevState.isProfileExpanded,
      isNotificationsExpanded: false,
      showMenu: false,
    }))
    this.props.logoutUser()
  }

  fetchMoreData = () => {
    const {
      user: { notifications },
      getUserNotifications,
    } = this.props
    if (notifications.meta.page < notifications.meta.pages) {
      getUserNotifications({ page: notifications.meta.page + 1 })
    }
  }

  resizeHeaderOnScroll = () => {
    const distanceY = window.pageYOffset || document.documentElement.scrollTop,
      shrinkOn = 220,
      navigationBar = document.getElementById("navbar-region")

    if (distanceY > shrinkOn) {
      navigationBar.classList.add("pinned")
    } else {
      navigationBar.classList.remove("pinned")
    }
  }

  handleShowMenu = () => {
    this.setState((prevState) => ({
      showMenu: !prevState.showMenu,
    }))
  }

  disableScroll = () => {
    const { showMenu } = this.state
    if (showMenu) {
      disableBodyScroll(this.targetElement)
    } else {
      enableBodyScroll(this.targetElement)
    }
  }

  handleMenuActions = () => {
    this.setState({ showMenu: false })
  }

  setActiveSubmenuItem = () => {
    this.setState((prevState) => ({
      activeSubmenuItem: !prevState.activeSubmenuItem,
    }))
  }

  handleGoToProfile = () => {
    history.push("/student/profile")
    this.setState({ showVerified: false })
  }

  closeVideoModal = () => {
    this.setState({ showVideoModal: false })
  }

  showVideoModal = () => {
    this.setState({ showVideoModal: true })
  }
  announcementToggle = (data) => {
    this.setState({ showAnnouncementModal: data })
  }

  render() {
    const {
      isProfileExpanded,
      isNotificationsExpanded,
      showMenu,
      showVerified,
      showVideoModal,
      showAnnouncementModal,
    } = this.state

    const {
      auth: { authModal, isAuthorized, role },
      school: { schoolData },
      user: {
        notifications: { count = 0, next, data = [] },
        userDetails,
        isLoadingNotification,
      },
      showAuthModal,
      closeAuthModal,
    } = this.props

    const showHowToButton = schoolData?.how_to_video ? true : false

    const faqLink = FAQS_LINK["school-" + schoolData?.id]

    return (
      <Fragment>
        {showVerified && isAuthorized && userDetails.is_verified && (
          <VerificationPopUp
            onRedirect={() => this.handleGoToProfile()}
            onClose={() => this.setState({ showVerified: false })}
          />
        )}
        <nav
          id="navbar-region"
          className="navbar-region"
          role="navigation"
          aria-label="main navigation"
        >
          <div className="navbar-wrapper">
            <Link className="partner-logo" to="/">
              <img src={schoolData.logo} alt={schoolData.name} />
            </Link>
            {showMenu ? (
              <div className="navbar-overlay">
                <div className="navbar-close">
                  <button
                    id="hamburger-icon"
                    className={showMenu ? "active" : ""}
                    onClick={() => this.handleShowMenu()}
                  >
                    <span aria-hidden="true" className="line line-1"></span>
                    <span aria-hidden="true" className="line line-2"></span>
                    <span aria-hidden="true" className="line line-3"></span>
                  </button>
                </div>
                <ul className="navbar-list">
                  {isAuthorized ? (
                    <>
                      {showHowToButton && (
                        <li>
                          <Button
                            label="How To"
                            block
                            size="large"
                            onClick={() => this.showVideoModal()}
                          />
                        </li>
                      )}
                      <li>
                        <Link
                          to={`/courses`}
                          className="nav-link"
                          onClick={() => this.handleShowMenu()}
                        >
                          Courses
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`/course-bundles`}
                          className="nav-link"
                          onClick={() => this.handleShowMenu()}
                        >
                          Course Bundles
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`/forums`}
                          className="nav-link"
                          onClick={() => this.handleShowMenu()}
                        >
                          Forums
                        </Link>
                      </li>
                      {faqLink && (
                        <li>
                          <Link
                            to={`/faqs`}
                            className="nav-link"
                            onClick={() => this.handleShowMenu()}
                          >
                            FAQs
                          </Link>
                        </li>
                      )}
                      <li>
                        <Link
                          to={"/student/profile"}
                          className="item"
                          onClick={() => this.handleShowMenu()}
                        >
                          My Profile
                        </Link>
                      </li>
                      {role === "ST" && (
                        <li>
                          <Link
                            to={"/student/courses"}
                            className="item"
                            onClick={() => this.handleShowMenu()}
                          >
                            My Courses
                          </Link>
                        </li>
                      )}
                      {role === "ST" && (
                        <li>
                          <Link
                            to={"/student/classes"}
                            className="item"
                            onClick={() => this.handleShowMenu()}
                          >
                            My Classes
                          </Link>
                        </li>
                      )}
                      {role === "ST" && (
                        <li>
                          <Link
                            to={"/student/certificates"}
                            className="item"
                            onClick={() => this.handleShowMenu()}
                          >
                            My Certificates
                          </Link>
                        </li>
                      )}
                      <div className="button-group">
                        <Button
                          label="Logout"
                          ghost
                          block
                          size="large"
                          onClick={() => this.handleLogoutUser()}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      {showHowToButton && (
                        <li>
                          <Button
                            label="How To"
                            block
                            size="large"
                            onClick={() => this.showVideoModal()}
                          />
                        </li>
                      )}
                      <li>
                        <Link
                          to={`/courses`}
                          className="nav-link"
                          onClick={() => this.handleShowMenu()}
                        >
                          Courses
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`/course-bundles`}
                          className="nav-link"
                          onClick={() => this.handleShowMenu()}
                        >
                          Course Bundles
                        </Link>
                      </li>
                      {faqLink && (
                        <li>
                          <Link
                            to={`/faqs`}
                            className="nav-link"
                            onClick={() => this.handleShowMenu()}
                          >
                            FAQs
                          </Link>
                        </li>
                      )}
                      <div className="button-group">
                        <Button
                          label="Login"
                          ghost
                          block
                          size="large"
                          onClick={() =>
                            showAuthModal({ type: AUTH_TYPES.LOGIN })
                          }
                        />
                        <Button
                          label="Sign Up"
                          block
                          size="large"
                          onClick={() =>
                            showAuthModal({ type: AUTH_TYPES.REGISTER })
                          }
                        />
                      </div>
                    </>
                  )}
                </ul>
              </div>
            ) : (
              <button
                className={showMenu ? "active" : ""}
                id="hamburger-icon"
                data-target="navbar-actions"
                onClick={() => this.handleShowMenu()}
              >
                <span aria-hidden="true" className="line line-1"></span>
                <span aria-hidden="true" className="line line-2"></span>
                <span aria-hidden="true" className="line line-3"></span>
              </button>
            )}

            <div className="navbar-actions" id="navbar-actions">
              {showHowToButton && (
                <Button
                  label="How To"
                  size="medium"
                  onClick={() => this.showVideoModal()}
                />
              )}
              <Link to={`/courses`} className="nav-link">
                Courses
              </Link>
              <Link to={`/course-bundles`} className="nav-link">
                Course Bundles
              </Link>

              {faqLink && (
                <Link to={`/faqs`} className="nav-link">
                  FAQs
                </Link>
              )}
              {isAuthorized && (
                <Link to={`/forums`} className="nav-link">
                  Forums
                </Link>
              )}
              <span className="separator" />
              {isAuthorized ? (
                <div
                  className="navbar-button"
                  ref={this.notificationDropDown}
                  onClick={() => this.showNotificationsDropdown()}
                >
                  <img src={NotificationIcon} alt="notification" />
                  {count > 0 && (
                    <span className="badge">{this.checkCounter(count)}</span>
                  )}
                  <div
                    className={cx(
                      "notification-component",
                      !isNotificationsExpanded && "is-not-active"
                    )}
                  >
                    <div className="notification-header">
                      <p className="text">Notifications</p>
                      <span className="badge">{count}</span>
                    </div>
                    <Notification
                      data={data}
                      next={this.fetchMoreData}
                      hasMore={next}
                      loader={<Spinner isFetching={isLoadingNotification} />}
                    />
                  </div>
                </div>
              ) : (
                <Button
                  label="Login"
                  size="medium"
                  ghost
                  onClick={() => showAuthModal({ type: AUTH_TYPES.LOGIN })}
                />
              )}

              {isAuthorized ? (
                <div
                  className={cx(
                    "navbar-button",
                    isProfileExpanded && "is-active"
                  )}
                  ref={this.profileDropDown}
                  onClick={() => this.showProfileDropdown()}
                >
                  <Avatar
                    size="40"
                    name={
                      userDetails.first_name && userDetails.last_name
                        ? userDetails.first_name.concat(
                            " ",
                            userDetails.last_name
                          )
                        : userDetails.username
                    }
                    src={userDetails.photo}
                  />
                  <div className="navbar-drop -avatar">
                    <Link to={"/student/profile"} className="item">
                      My Profile
                    </Link>
                    {role === "ST" && (
                      <Link to={"/student/courses"} className="item">
                        My Courses
                      </Link>
                    )}
                    {role === "ST" && (
                      <Link to={"/student/classes"} className="item">
                        My Classes
                      </Link>
                    )}
                    {role === "ST" && (
                      <Link to={"/student/certificates"} className="item">
                        My Certificates
                      </Link>
                    )}
                    <a
                      className="item"
                      onClick={() => this.handleLogoutUser()}
                      href="# "
                    >
                      Logout
                    </a>
                  </div>
                </div>
              ) : (
                <Button
                  label="Sign up"
                  size="medium"
                  onClick={() => showAuthModal({ type: AUTH_TYPES.REGISTER })}
                />
              )}
            </div>
          </div>

          <AuthModal
            isOpen={authModal.isShowing}
            authType={authModal.type}
            closeModal={() => closeAuthModal()}
          />
          <VideoModal
            isOpen={showVideoModal}
            videoUrl={schoolData?.how_to_video}
            closeModal={() => this.closeVideoModal()}
          />
          <CustomModal
            type={"announcement-no-border"}
            isOpen={showAnnouncementModal}
            closeModal={() => this.announcementToggle(false)}
          />
        </nav>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  auth: state.authReducer,
  school: state.schoolReducer,
  user: state.userReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAuthModal,
      closeAuthModal,
      logoutUser,
      getUserNotifications,
      getUserProfile,
      getCompliancePeriod,
    },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(NavigationBar)
